/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreProjectTaskResponseDto } from '../../models/core-project-task-response-dto';

export interface ProjectTasksControllerFindAllByTenant$Params {

/**
 * Tenant ID
 */
  tenant: string;
}

export function projectTasksControllerFindAllByTenant(http: HttpClient, rootUrl: string, params: ProjectTasksControllerFindAllByTenant$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<Array<CoreProjectTaskResponseDto>>> {
  const rb = new CoreRequestBuilder(rootUrl, projectTasksControllerFindAllByTenant.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<Array<CoreProjectTaskResponseDto>>;
    })
  );
}

projectTasksControllerFindAllByTenant.PATH = '/o2-core/project-tasks/{tenant}';
